import { Box, useTheme } from "@mui/material";
import NavBar from "./components/NavBar";
import AppHomeContent from "./components/AppHomeContent";
import { tokens } from "../../theme";
import WeatherWidget from "./components/WeatherWidget";

const AppHome = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  return (
    <Box
      sx={{
        minHeight: "100vh",
        backgroundColor: colors.primary[900],
        display: "flex",
        flexDirection: "column",
      }}
    >
      <NavBar />
      <AppHomeContent />
      <WeatherWidget />
      {/* <MemoryBookSummary /> */}
    </Box>
  );
};

export default AppHome;
